import React, { useState } from 'react';
import './index.css'; // Import the CSS file for styles
import { useGlobalLoading } from '../../hooks/useGlobalLoading';

const LoginComponent = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [, setSession] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { startLoading, stopLoading } = useGlobalLoading();

  // Helper function to set cookies
  const setCookie = (name, value, days = 1) => {
    const expires = days ? new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString() : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; domain=.eposgestofinal.com`;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    startLoading('A fazer login...');
    setErrorMessage('');

    const payload = {
      uname: username,
      upass: password,
    };

    try {
      const response = await fetch('https://eposgestofinal.com/api/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Important to receive cookies
        body: JSON.stringify(payload),
      });

      // Check if the response is ok
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      if (data.valid) {
        setSession(data);
        
        // Store in cookies (primary method)
        setCookie('token', data.token, 1); // 1 day
        setCookie('idempresa', data.idempresa, 1);
        setCookie('avatar', data.avatar, 1);
        
        // Keep localStorage for backward compatibility (fallback)
        localStorage.setItem('token', data.token);
        localStorage.setItem('public_indentifier', data.idempresa);
        localStorage.setItem('avatar', data.avatar);
        
        // Redirect user or perform other actions as needed
        window.location.reload();
      } else {
        setErrorMessage('Invalid username or password.');
      }
    } catch (error) {
      setErrorMessage('An error occurred during login: ' + error.message);
      console.error('Login error:', error);
    } finally {
      setIsSubmitting(false);
      stopLoading();
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Torniquete</h2>
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <button type="submit" disabled={isSubmitting} className="login-button">
            {isSubmitting ? 'A fazer login...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginComponent;
